import { Ban, Brain, TrendingDown, Gavel, DollarSign, HeartCrack } from "lucide-react";

const risks = [
  { icon: Ban, text: "Paralisação decisória", priority: 1 },
  { icon: DollarSign, text: "Destruição de patrimônio e legado", priority: 2 },
  { icon: Brain, text: "Desgaste emocional entre sócios", priority: 3 },
  { icon: TrendingDown, text: "Perda de valor da empresa" },
  { icon: HeartCrack, text: "Rupturas traumáticas" },
  { icon: Gavel, text: "Judicialização desnecessária" },
];

const RiskSection = () => (
  <section className="bg-background py-14 md:py-20">
    <div className="container mx-auto px-6">
      <div className="max-w-3xl mx-auto text-center mb-16">
        <p className="text-primary font-body font-semibold tracking-widest uppercase text-[13px] mb-5">Alerta</p>
        <h2 className="text-[25px] md:text-[31px] lg:text-[39px] font-heading font-bold leading-[1.2em] tracking-[-1px] mb-6">O Risco Invisível</h2>
        <p className="text-[16px] text-muted-foreground font-body font-normal leading-[1.5em]">
          Conflitos societários raramente começam grandes.<br />
          <strong className="text-foreground font-bold">Eles começam mal resolvidos.</strong>
        </p>
        <p className="text-[16px] text-muted-foreground font-body font-normal mt-4 leading-[1.5em]">
          Quando ignorados, costumam evoluir para:
        </p>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 max-w-4xl mx-auto mb-16">
        {risks.map((risk, i) => (
          <div key={i} className="flex items-center gap-3 p-4 rounded-lg border border-border bg-card">
            <risk.icon className="w-6 h-6 text-primary shrink-0" />
            <span className="font-body text-[16px] font-normal text-card-foreground leading-[1.5em]">{risk.text}</span>
          </div>
        ))}
      </div>

      <div className="max-w-2xl mx-auto text-center border-l-4 border-primary pl-6 py-4 bg-primary/5 rounded-r-lg">
        <p className="text-[16px] font-body italic text-foreground/80 leading-[1.5em]">
          Esperar o conflito "se resolver sozinho" costuma ser a decisão mais cara.
        </p>
      </div>
    </div>
  </section>
);

export default RiskSection;
